import { useEffect, useState } from "react";
import { AlertTriangle, X } from "lucide-react";
import api from "../../lib/api";

/* Red breaking-news strip shown when a major safety story hits (auto-detected
   from the last 48h or pinned by an admin). Dismissible per session. */
export const BreakingBanner = () => {
  const [item, setItem] = useState(null);
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("aa_breaking_dismissed") === "1");

  useEffect(() => {
    api.get("/v1/news/breaking").then((r) => setItem((r.data.items || [])[0] || null)).catch(() => {});
  }, []);

  if (!item || hidden) return null;

  const dismiss = () => { sessionStorage.setItem("aa_breaking_dismissed", "1"); setHidden(true); };

  return (
    <div className="bg-red-700 text-white" data-testid="aa-breaking-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2 flex items-center gap-2 min-w-0">
        <span className="inline-flex items-center gap-1 shrink-0 bg-white/15 rounded px-1.5 py-0.5 text-[10px] font-900 uppercase tracking-wider">
          <AlertTriangle className="w-3 h-3" /> Breaking
        </span>
        <a href={item.url} target="_blank" rel="noopener noreferrer" data-testid="aa-breaking-link"
          className="flex-1 min-w-0 truncate text-xs sm:text-sm font-700 hover:underline">
          {item.title}
          {item.source && <span className="ml-2 font-400 text-red-200 hidden sm:inline">— {item.source}</span>}
        </a>
        <button onClick={dismiss} aria-label="Dismiss breaking news" data-testid="aa-breaking-dismiss"
          className="shrink-0 p-1 rounded hover:bg-white/15 transition-colors">
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};
